import { render, staticRenderFns } from "./InviteList.vue?vue&type=template&id=083cd55b&scoped=true&"
import script from "./InviteList.vue?vue&type=script&lang=js&"
export * from "./InviteList.vue?vue&type=script&lang=js&"
import style0 from "./InviteList.vue?vue&type=style&index=0&id=083cd55b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cd55b",
  null
  
)

export default component.exports